/*---------------------------------------------------------------
 ?? Project: Ring2All Platform
 ????? Author: Rodrigo Cuadra
 ?? Company: Ring2All LLC
 ?? File: hooks\useEmailTemplateColumns.tsx
 ??? Created: 2026-05-02
 ?? Description:
    Implementation of the email-templates module.
----------------------------------------------------------------*/

import React, { useMemo } from 'react';
import { Badge } from '@/components/ui/badge';
import { useI18n } from '@/hooks/useI18n';

export const useEmailTemplateColumns = () => {
    const { t, i18n } = useI18n();

    const availableColumns = useMemo(() => [
        {
            key: 'name',
            label: t('emailTemplates.columns.name'),
            visible: true,
            sortable: true,
            render: (value: string) => (
                <span className="font-semibold text-primary">{value}</span>
            )
        },
        {
            key: 'fromEmail',
            label: t('emailTemplates.columns.fromEmail'),
            visible: true,
            sortable: true,
            render: (value: string) => (
                <span className="text-sm text-muted-foreground italic">{value || '-'}</span>
            )
        },
        {
            key: 'subject',
            label: t('emailTemplates.columns.subject'),
            visible: true,
            sortable: true,
            render: (value: string) => (
                <span className="truncate max-w-[200px] block" title={value}>{value}</span>
            )
        },
        {
            key: 'isActive',
            label: t('emailTemplates.columns.isActive'),
            visible: true,
            sortable: true,
            render: (value: boolean) => (
                <Badge variant={value ? 'default' : 'secondary'} className={value ? 'bg-green-500/10 text-green-600 border-green-500/20' : ''}>
                    {value ? t('common.active') : t('common.inactive')}
                </Badge>
            )
        },
        {
            key: 'actions',
            label: '',
            visible: true,
            sortable: false,
            align: 'right' as const,
            width: '120px'
        }
    ], [t, i18n.language]);

    return { availableColumns };
};
